
export default {
  name: 'PageBrochureBookPrefill',

  head() {
    return {
      title: `Book ${this.compPaddock.name}`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Book a session at ${this.compPaddock.name}`
        }
      ]
    }
  },

  computed: {
    compPaddock() {
      return this.$store.getters['paddocks/paddockBySlug'](this.$route.params.slug) || {}
    }
  }
}
